import React from "react";
import banner from "../../../Assets/Images/About/banner.png";
import "./style.scss";
import { useTranslation } from "react-i18next";

function Banner() {
  const { t } = useTranslation();
    
  return (
    <div className="banner">
      <img src={banner} alt="" />
      <div className="banner-title">
        <div className="title">
          <h2>{t("banner.title")}</h2>
        </div>
        <div className="subtitle">
          <p>{t("banner.subtitle")}</p>
        </div>
      </div>

      <div className="banner-detail">
        <p>
          {t("banner.detailLine1")} <br />
          {t("banner.detailLine2")} <br />
          {t("banner.detailLine3")} <br />
          {t("banner.detailLine4")}
        </p>
      </div>
    </div>
  );
}

export default Banner;
